import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

// 路由配置
const routes = [
  {
    path: '/',
    redirect: () => {
      // 根路径按登录态分流：已登录进考试首页，未登录进登录页
      return localStorage.getItem('exam_token') ? '/exam/index' : '/exam/login'
    }
  },
  {
    path: '/exam',
    redirect: '/exam/login',
    children: [
      {
        path: 'login',
        name: 'ExamLogin',
        component: () => import('@/views/front/exam/login.vue'),
        meta: {
          title: '考试登录'
        }
      },
      {
        path: 'index',
        name: 'ExamIndex',
        component: () => import('@/views/front/exam/index.vue'),
        meta: {
          title: '考试首页',
          requiresAuth: true
        }
      },
      {
        path: 'paper',
        name: 'ExamPaper',
        component: () => import('@/views/front/exam/paper.vue'),
        meta: {
          title: '考试答题',
          requiresAuth: true
        }
      },
      {
        path: 'camera-upload',
        name: 'CameraUpload',
        component: () => import('@/views/front/exam/camera-upload.vue'),
        meta: {
          title: '拍照上传'
        }
      },
      {
        path: 'camera-performance-test',
        name: 'CameraPerformanceTest',
        component: () => import('@/views/front/exam/camera-performance-test.vue'),
        meta: {
          title: '相机性能测试'
        }
      }
    ]
  },
  {
    path: '/manage/login',
    name: 'ManageLogin',
    component: () => import('@/views/manage/setting/login.vue'),
    meta: {
      title: '考试系统管理登录'
    }
  },
  {
    path: '/manage',
    component: () => import('@/views/manage/layout.vue'),
    children: [
      {
        path: 'index',
        name: 'ManageIndex',
        component: () => import('@/views/manage/index.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: 'user',
        name: 'ManageUser',
        component: () => import('@/views/manage/user.vue'),
        meta: {
          title: '考生管理'
        }
      },
      {
        path: 'paperCate',
        name: 'ManagePaperCate',
        component: () => import('@/views/manage/paperCate.vue'),
        meta: {
          title: '试卷分类管理'
        }
      },
      {
        path: 'paper',
        name: 'ManagePaper',
        component: () => import('@/views/manage/paper.vue'),
        meta: {
          title: '试卷管理'
        }
      },
      {
        path: 'paperDetail',
        name: 'ManagePaperDetail',
        component: () => import('@/views/manage/paperDetail.vue'),
        meta: {
          title: '模块与题目'
        }
      },
      {
        path: 'setting/role',
        name: 'ManageSettingRole',
        component: () => import('@/views/manage/setting/role.vue'),
        meta: {
          title: '角色管理'
        }
      },
      {
        path: 'setting/menu',
        name: 'ManageSettingMenu',
        component: () => import('@/views/manage/setting/menu.vue'),
        meta: {
          title: '菜单管理'
        }
      },
      {
        // 兜底：未开发页面统一显示"开发中"
        path: ':pathMatch(.*)*',
        name: 'ManageUnderConstruction',
        component: () => import('@/views/manage/underConstruction.vue'),
        meta: {
          title: '页面开发中'
        }
      },
      {
        path: 'setting/user',
        name: 'ManageSettingUser',
        component: () => import('@/views/manage/setting/user.vue'),
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'setting/dept',
        name: 'ManageSettingDept',
        component: () => import('@/views/manage/setting/dept.vue'),
        meta: {
          title: '部门管理'
        }
      },
      {
        path: 'setting/post',
        name: 'ManageSettingPost',
        component: () => import('@/views/manage/setting/post.vue'),
        meta: {
          title: '岗位管理'
        }
      }
    ]
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 当离开 /exam/paper 路由时，关闭 WebSocket 连接
  if (from.path === '/exam/paper' && to.path !== '/exam/paper') {
    console.log('离开 /exam/paper 路由，关闭 WebSocket 连接')
    store.dispatch('closeWebSocket')
  }

  // 管理端登录拦截：/manage/* 除登录页外，未登录统一跳管理登录页
  if (to.path.startsWith('/manage') && to.path !== '/manage/login') {
    const token = localStorage.getItem('exam_token')
    if (!token) {
      next({ path: '/manage/login', query: { redirect: to.fullPath } })
      return
    }
  }

  // 管理登录页：已登录则直接进管理首页（跳过被踢出前的目标页由 redirect 处理）
  if (to.path === '/manage/login') {
    const token = localStorage.getItem('exam_token')
    if (token) {
      next('/manage/index')
      return
    }
  }

  next()
})

export default router
